import useSWR, { type Fetcher } from 'swr';
import { z } from 'zod';

import { oemsList } from '~/data/generated/endpoints/oems/oems';
import { parseApiResponse } from '~/data/parseApiResponse';
import { type OEM, oemListResponseSchema, oemSchema } from '~/data/schemas/oem';

const carOemsFetcher: Fetcher<OEM[], readonly [key: 'oems']> = async () => {
  const { data } = await oemsList();
  // LimitOffset pagination with no default page size returns a bare array when
  // no `limit` is passed. It doesn't match the paginated envelope, so validate
  // that shape directly instead.
  if (Array.isArray(data)) return parseApiResponse(z.array(oemSchema), data, 'OEM');
  return parseApiResponse(oemListResponseSchema, data, 'OEM').results;
};

export const useOEMs = () => {
  const { data: oems } = useSWR(['oems'], carOemsFetcher, {});
  return { oems };
};
